module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-04.2f696241.jpg";